import { render, staticRenderFns } from "./SkalaUsaha.vue?vue&type=template&id=e0c88e4c&"
import script from "./SkalaUsaha.vue?vue&type=script&lang=js&"
export * from "./SkalaUsaha.vue?vue&type=script&lang=js&"
import style0 from "./SkalaUsaha.vue?vue&type=style&index=0&id=e0c88e4c&prod&lang=css&"
import style1 from "./SkalaUsaha.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports